import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { Spin, message } from 'antd'
import CloudFlyerAPI from '../api/CloudFlyerAPI'
import Filters from '../components/Analytics/filters'
import ChartTabs from '../components/Analytics/chart-tabs'
import EmptyState from '../components/Shared/EmptyState'

import PricingModal from '../components/PricingModal'

import { fetchCloudAccounts } from '../actions/cloud-accounts-actions'

import {
    fetchOverviewChart,
    fetchServicesHistory,
    fetchS3Chart,
    fetchBucketCostChart,
    fetchEC2Chart,
    fetchDataTransferChart,
    fetchRDSChart,
    fetchDatabaseCostChart,
    fetchCloudWatchChart,
    fetchEFSChart,
    fetchEFSUsage,
    fetchDirectConnectChart,
    fetchSupportChart,
    fetchRoute53Chart,
    fetchInvoiceDownload,
    changeCloudAccount,
    changeBucketCostBucket,
    changeBucketCostUsageType,
    clearFilterBucketCost,
    changeDatabaseCostDatabase,
    changeDatabaseCostUsageType,
    clearFilterDatabaseCost,
} from '../actions/analytics-actions'

let states = {}
let $this = null
let stateBucket = {}

class AnalyticsContainer extends React.Component {
    constructor(props) {
        super(props)

        const { user } = this.props
        this.hasAccess =
            user.packages &&
            user.packages.map(p => p.title).includes('Analytics')

        $this = this
        $this.provider = props.state ? props.state : 'state'
        const d = new Date()
        this.state = {
            selectedAccount: null,
            selectedYear: d.getFullYear(),
            selectedMonth: d.getMonth() + 1,
            bucket: null,
            dl_loading: false,
        }
        //this.handleCloudAccountChange = this.handleCloudAccountChange.bind(this)
    }

    componentDidMount() {
        this.props.fetchCloudAccounts()
        console.log('PROPS → ', this.props)
    }

    componentWillReceiveProps(props) {
        if (!this.state.selectedAccount && props.selectedAccount) {
            this.setState(
                {
                    selectedAccount: props.selectedAccount,
                },
                () => this.on_cloud_account_change(props.selectedAccount.id)
            )
        }
    }

    componentDidCatch(err, details) {
        console.error(err, details)
    }

    load_first = () => {
        //  this.props.changeCloudAccount(this.props.cloudAccounts[0])
    }

    on_download = file => {
        let $this = this

        console.log('siamamk')
        $this.setState({
            dl_loading: true,
        })

        let file_names = []

        if (file && !file.checked) file_names.push(file.path)
        else
            for (let i = 0; i < $this.state.files.length; i++) {
                let fl = $this.state.files[i]
                if (fl.checked) {
                    file_names.push(fl.path)
                }
            }

        CloudFlyerAPI.transfer
            .download_url(
                this.state.bucket.cloud_account_id,
                this.state.bucket.bucket_name,
                file_names
            )
            .then(response => {
                $this.setState({
                    dl_loading: false,
                })

                if (!(response || {}).data) {
                    return message.error(
                        'failed to generate download link, please retry again'
                    )
                }

                $this.setState(
                    {
                        download_files: [],
                    },
                    () =>
                        $this.setState({
                            download_files: (response || {}).data,
                        })
                )
            })
            .catch(function(err) {
                $this.setState({
                    dl_loading: false,
                })
                message.error(err)
            })
    }

    on_cloud_account_change = cloudAccountId => {
        let analyticMonth
        let selectedAcc

        this.state.selectedMonth < 10
            ? (analyticMonth =
                  this.state.selectedYear.toString() +
                  '0' +
                  this.state.selectedMonth.toString())
            : (analyticMonth =
                  this.state.selectedYear.toString() +
                  this.state.selectedMonth.toString())

        this.props.cloudAccounts.map(cloudAccount => {
            if (cloudAccount.id === cloudAccountId) {
                this.props.changeCloudAccount(cloudAccount)
                stateBucket.cloud_account_id = cloudAccountId
                stateBucket.bucket_name = cloudAccount.billing_bucket

                console.log(cloudAccount)
                selectedAcc = cloudAccount
                this.setState({
                    selectedAccount: cloudAccount,
                    bucket: stateBucket,
                })
                console.log(selectedAcc)
                console.log(this.state)
            }
        })
        //this.state.selectedAccount && console.log(selectedAcc.billing_bucket)

        this.props.clearFilterBucketCost()
        this.props.fetchServicesHistory(1, 10, 'file_catalyst')
        this.props.fetchOverviewChart(cloudAccountId, analyticMonth)
        this.props.fetchS3Chart(cloudAccountId, analyticMonth)
        this.props.fetchBucketCostChart(cloudAccountId, analyticMonth)
        this.props.fetchEC2Chart(cloudAccountId, analyticMonth)
        this.props.fetchDataTransferChart(cloudAccountId, analyticMonth)
        this.props.fetchRDSChart(cloudAccountId, analyticMonth)
        this.props.fetchDatabaseCostChart(cloudAccountId, analyticMonth)
        this.props.fetchCloudWatchChart(cloudAccountId, analyticMonth)
        this.props.fetchEFSChart(cloudAccountId, analyticMonth)
        this.props.fetchEFSUsage(cloudAccountId)
        this.props.fetchDirectConnectChart(cloudAccountId, analyticMonth)
        this.props.fetchSupportChart(cloudAccountId, analyticMonth)
        this.props.fetchRoute53Chart(cloudAccountId, analyticMonth)

        let bucket = cloudAccountId + '/' + selectedAcc.billing_bucket

        this.state.selectedAccount &&
            this.props.fetchInvoiceDownload(bucket, '/')
    }

    on_year_change = year => {
        this.setState({
            selectedYear: year,
        })
        let analyticMonth
        this.state.selectedMonth < 10
            ? (analyticMonth =
                  this.state.selectedYear.toString() +
                  '0' +
                  this.state.selectedMonth.toString())
            : (analyticMonth =
                  this.state.selectedYear.toString() +
                  this.state.selectedMonth.toString())

        this.props.clearFilterBucketCost()
        this.props.fetchServicesHistory(1, 10, 'file_catalyst')
        this.props.fetchOverviewChart(
            this.state.selectedAccount.id,
            analyticMonth
        )
        this.props.fetchS3Chart(this.state.selectedAccount.id, analyticMonth)
        this.props.fetchBucketCostChart(
            this.state.selectedAccount.id,
            analyticMonth
        )
        this.props.fetchEC2Chart(this.state.selectedAccount.id, analyticMonth)
        this.props.fetchDataTransferChart(
            this.state.selectedAccount.id,
            analyticMonth
        )
        this.props.fetchRDSChart(this.state.selectedAccount.id, analyticMonth)
        this.props.fetchDatabaseCostChart(
            this.state.selectedAccount.id,
            analyticMonth
        )
        this.props.fetchCloudWatchChart(
            this.state.selectedAccount.id,
            analyticMonth
        )
        this.props.fetchEFSChart(this.state.selectedAccount.id, analyticMonth)
        this.props.fetchEFSUsage(this.state.selectedAccount.id)
        this.props.fetchDirectConnectChart(
            this.state.selectedAccount.id,
            analyticMonth
        )
        this.props.fetchSupportChart(
            this.state.selectedAccount.id,
            analyticMonth
        )
        this.props.fetchRoute53Chart(
            this.state.selectedAccount.id,
            analyticMonth
        )
    }

    on_month_change = month => {
        this.setState({
            selectedMonth: month,
        })

        let analyticMonth
        month < 10
            ? (analyticMonth =
                  this.state.selectedYear.toString() + '0' + month.toString())
            : (analyticMonth =
                  this.state.selectedYear.toString() + month.toString())

        this.props.clearFilterBucketCost()
        this.props.fetchServicesHistory(1, 10, 'file_catalyst')
        this.props.fetchOverviewChart(
            this.state.selectedAccount.id,
            analyticMonth
        )
        this.props.fetchS3Chart(this.state.selectedAccount.id, analyticMonth)
        this.props.fetchBucketCostChart(
            this.state.selectedAccount.id,
            analyticMonth
        )
        this.props.fetchEC2Chart(this.state.selectedAccount.id, analyticMonth)
        this.props.fetchDataTransferChart(
            this.state.selectedAccount.id,
            analyticMonth
        )
        this.props.fetchRDSChart(this.state.selectedAccount.id, analyticMonth)
        this.props.fetchDatabaseCostChart(
            this.state.selectedAccount.id,
            analyticMonth
        )
        this.props.fetchCloudWatchChart(
            this.state.selectedAccount.id,
            analyticMonth
        )
        this.props.fetchEFSChart(this.state.selectedAccount.id, analyticMonth)
        this.props.fetchEFSUsage(this.state.selectedAccount.id)
        this.props.fetchDirectConnectChart(
            this.state.selectedAccount.id,
            analyticMonth
        )
        this.props.fetchSupportChart(
            this.state.selectedAccount.id,
            analyticMonth
        )
        this.props.fetchRoute53Chart(
            this.state.selectedAccount.id,
            analyticMonth
        )
    }

    on_bucket_change = bucketId => {
        let bucketCostData = {
            selectedBucket: {},
            usageTypeChartData: [],
        }
        this.props.analytics.chartsData.bucketCostData.bucketCosts.map(
            bucket => {
                bucket.bucket_name === bucketId &&
                    (bucketCostData.selectedBucket = bucket)
            }
        )

        bucketCostData.selectedBucket.usage_types.map(usageType => {
            bucketCostData.usageTypeChartData.push([
                usageType.usage_type,
                usageType.cost,
            ])
        })
        this.props.changeBucketCostBucket(bucketCostData)
    }

    on_bucket_usage_type_change = usageTypeId => {
        let bucketCostData = {
            selectedUsageType: {},
            operationChartData: [],
        }
        this.props.analytics.chartsData.bucketCostData.selectedBucket.usage_types.map(
            usageType => {
                usageType.usage_type === usageTypeId &&
                    (bucketCostData.selectedUsageType = usageType)
            }
        )

        bucketCostData.selectedUsageType.operations.map(operation => {
            bucketCostData.operationChartData.push([
                operation.operation,
                operation.cost,
            ])
        })

        this.props.changeBucketCostUsageType(bucketCostData)
    }

    on_clear_filter_bucket_cost = () => {
        this.props.clearFilterBucketCost()
    }

    on_database_change = databaseId => {
        let databaseCostData = {
            selectedDatabase: {},
            usageTypeChartData: [],
        }
        this.props.analytics.chartsData.databaseCostData.databaseCosts.map(
            database => {
                database.database_name === databaseId &&
                    (databaseCostData.selectedDatabase = database)
            }
        )

        databaseCostData.selectedDatabase.usage_types.map(usageType => {
            databaseCostData.usageTypeChartData.push([
                usageType.usage_type,
                usageType.cost,
            ])
        })
        this.props.changeDatabaseCostDatabase(databaseCostData)
    }

    on_database_usage_type_change = usageTypeId => {
        let databaseCostData = {
            selectedUsageType: {},
            operationChartData: [],
        }
        this.props.analytics.chartsData.databaseCostData.selectedDatabase.usage_types.map(
            usageType => {
                usageType.usage_type === usageTypeId &&
                    (databaseCostData.selectedUsageType = usageType)
            }
        )

        databaseCostData.selectedUsageType.operations.map(operation => {
            databaseCostData.operationChartData.push([
                operation.operation,
                operation.cost,
            ])
        })

        this.props.changeDatabaseCostUsageType(databaseCostData)
    }

    on_clear_filter_database_cost = () => {
        this.props.clearFilterDatabaseCost()
    }

    render() {
        const {
            history,
            productsTotalCost,
            chartsData,
            servicesData,
            cloudAccounts,
            allCloudAccounts,
            loading,
            error,
        } = this.props

        const { download_files = [] } = this.state

        const pricingModal = (
            <PricingModal
                productName="Analytics"
                product="analytics"
                monthlyPricing={20}
                annuallyPricing={199}
                onClose={period => console.log('confirmed : ' + period)}
            />
        )

        if (loading) {
            return (
                <Spin
                    size="large"
                    tip="Loading..."
                    style={{ padding: '15% 50%', margin: '0 auto' }}
                />
            )
        }

        if (allCloudAccounts.length === 0) {
            return (
                <div>
                    {!this.hasAccess && pricingModal}
                    <EmptyState
                        title="You have no cloud account"
                        description="add your first cloud account here"
                        click_text="add"
                        on_click={() => history.push('/addProvider')}
                    />
                </div>
            )
        }

        if (cloudAccounts.length === 0) {
            return (
                <div>
                    {!this.hasAccess && pricingModal}
                    <EmptyState
                        title="You need to configure a billing bucket to use Analytics feature"
                        description='Please go back to Hybrid page and click on "i" icon under Usage colum to setup your billing bucket'
                        click_text="Go to Hybrid Page"
                        on_click={() => history.push('/')}
                    />
                </div>
            )
        }

        return (
            !error &&
            cloudAccounts &&
            this.state.selectedAccount && (
                <div>
                    {!this.hasAccess && pricingModal}
                    <Filters
                        on_cloud_account_change={this.on_cloud_account_change.bind(
                            this
                        )}
                        on_year_change={this.on_year_change.bind(this)}
                        on_month_change={this.on_month_change.bind(this)}
                        selectedAccount={this.state.selectedAccount}
                        selectedYear={this.state.selectedYear}
                        selectedMonth={this.state.selectedMonth}
                        cloudAccounts={cloudAccounts}
                    />

                    <ChartTabs
                        handleCloudAccountChange={this.handleCloudAccountChange}
                        on_download={this.on_download.bind(this)}
                        on_bucket_change={this.on_bucket_change.bind(this)}
                        on_bucket_usage_type_change={this.on_bucket_usage_type_change.bind(
                            this
                        )}
                        on_clear_filter_bucket_cost={this.on_clear_filter_bucket_cost.bind(
                            this
                        )}
                        on_database_change={this.on_database_change.bind(this)}
                        on_database_usage_type_change={this.on_database_usage_type_change.bind(
                            this
                        )}
                        on_clear_filter_database_cost={this.on_clear_filter_database_cost.bind(
                            this
                        )}
                        selectedAccount={this.state.selectedAccount}
                        selectedMonth={this.state.selectedMonth}
                        chartsData={chartsData}
                        servicesData={servicesData}
                        cloudAccounts={cloudAccounts}
                        productsTotalCost={productsTotalCost}
                    />

                    <div className={'hidden'}>
                        {download_files.map((file, i) => {
                            return (
                                <iframe
                                    key={i}
                                    download={file.url}
                                    src={file.url}
                                />
                            )
                        })}
                    </div>
                </div>
            )
        )
    }
}

const mapStateToProps = ({ analytics, cloudAccounts, auth }) => {
    let selectedAccount = null
    let cloudAccountsList = []
    let allCloudAccounts = []
    cloudAccounts.items.map(cloudAccount => {
        allCloudAccounts.push(cloudAccount)
        cloudAccount.billing_bucket && cloudAccountsList.push(cloudAccount)
    })
    cloudAccounts = cloudAccountsList

    cloudAccounts &&
        cloudAccounts.length > 0 &&
        (selectedAccount = cloudAccounts[0])

    return {
        ...analytics,
        analytics,
        allCloudAccounts,
        cloudAccounts,
        selectedAccount,
        user: auth.user,
    }
}

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchCloudAccounts,
            fetchOverviewChart,
            fetchServicesHistory,
            fetchS3Chart,
            fetchBucketCostChart,
            fetchEC2Chart,
            fetchDataTransferChart,
            fetchRDSChart,
            fetchDatabaseCostChart,
            fetchCloudWatchChart,
            fetchEFSChart,
            fetchEFSUsage,
            fetchDirectConnectChart,
            fetchSupportChart,
            fetchRoute53Chart,
            fetchInvoiceDownload,
            changeCloudAccount,
            changeBucketCostBucket,
            changeBucketCostUsageType,
            clearFilterBucketCost,
            changeDatabaseCostDatabase,
            changeDatabaseCostUsageType,
            clearFilterDatabaseCost,
        },
        dispatch
    )

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(AnalyticsContainer)
)
